module.exports = __webpack_public_path__ + "images/c0b9f3b0b2dfc03ec014527056abdfdc0bbc1801b75e0e0bf79d5c49e44f2d98.svg";